export default "__VITE_ASSET__$tWon7UC__"